


























































































































































import ToTopPage from '@/components/molecules/ToTopPage.vue'
import { AuthErrorEvent } from '@/components/organisms/dialog/error-dialog/events'
import * as CurrentTime from '@/models/current-time/functions'
import ForgotPasswordImageLink from '@spa/components/pages/auth/signup/shared/forgot-password/ImageLink.vue'

import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CookieService } from '@spa/services/cookie'

import ClipboardIcon from '@/components/atoms/ClipboardIcon.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import CrossPageTransition from '@/mixin/cross-page-transition'
import { RawTag } from '@/models/api/tags'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import Password from '@/util/password'
import MailMagazine from '@spa/components/organisms/mail-magazine/MailMagazine.vue'
import { Decorator, Decorators } from '@spa/components/organisms/mail-magazine/model'
import { loadingFormParts, SignUpFormParts } from '@spa/components/pages/auth/signup/shared/form-parts/form-parts'
import { createSignUpFormParts } from '@spa/components/pages/auth/signup/shared/form-parts/form-parts-factory'
import { RegistrationPayload } from '@spa/store/modules/user/actions'
import { createRegistrationPayload } from '@spa/store/modules/user/functions'
import { UserState } from '@spa/store/modules/user/types'
import { loadingParts, SignUpCompletedPageParts } from './completed/completed-page-parts'
import { createSignUpCompletedPageParts } from './completed/completed-page-parts-factory'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    ToTopPage,
    ClipboardIcon,
    SpaErrorDialog,
    MailMagazine,
    ForgotPasswordLink: ForgotPasswordImageLink,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Signup extends Mixins<PluginMixin & CrossPageTransition>(PluginMixin, CrossPageTransition) {
  @Prop({ default: null })
  /**
   * @see SignupPageProps.next
   */
  next: string | null

  // TODO: `status: Status = Status.Loading` とすると、直後に StoreCommit の `view/stopLoading` が飛び、ローディングが非表示になってしまう不具合を解決する
  // tslint:disable-next-line:max-line-length
  // SEE: https://github.com/my-color/front/pull/1142/files/3ff4e9213d087d2a3d8960864a0be0010825d90a..1d6799fa1ec780129924c1b9dda77c7969d079b5#pullrequestreview-230109780
  status: Status = Status.Pending

  email: string = ''

  password: string = ''

  passwordConfirmed: string = ''

  /**
   * 画面に表示する内容が、フォーム入力内容の確認状態であるかどうかを示す。
   * ローディングに関する状態管理と統合して、SignUpコンポーネント自前の状態として定義しなおすことも検討したい。
   */
  isConfirming: boolean = false

  currentTime = CurrentTime.create()

  behaviorConfig = new BehaviorConfig()

  mailMagazines: RawTag[] = []

  formParts: SignUpFormParts = loadingFormParts

  completedPageParts: SignUpCompletedPageParts = loadingParts

  initialized() {
    if (!this.isFailed) {
      this.status = Status.Pending
    }
  }

  get decorator(): Decorator {
    return Decorators.subscribeAll
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get isFailed(): boolean {
    return this.status === Status.Failed
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  get error(): Error {
    return this.$store.state.user.error.register
  }

  get hasDuplicateEmailError(): boolean {
    const cause: string = _.get(this.error, 'response.body.message', '')

    return cause.includes('already exists')
  }

  get hasTimeoutError(): boolean {
    const byTimeout: number | undefined = _.get(this.error, 'timeout')

    return byTimeout !== undefined
  }

  get isRegisteredUser(): boolean {
    return CookieService.hasAccessToken() && CookieService.isRegistered()
  }

  get dummyPassword(): string {
    return Password.generateMasked()
  }

  get mailMagazinesWithFollow(): RawTag[] {
    return this.mailMagazines.filter(mailMagazine => mailMagazine.follow)
  }

  backToSignupPage(): void {
    if (!this.isFailed) {
      this.status = Status.Loading
    }
    this.isConfirming = false
    window.scrollTo(0, 0)
  }

  created() {
    this.status = Status.Loading
    this.formParts = createSignUpFormParts(this.behaviorConfig)
    this.completedPageParts = createSignUpCompletedPageParts(this.behaviorConfig)
  }

  get validatorErrors(): Array<{ field: string }> {
    return this.$validator.errors.items
  }

  get hasPasswordValidationError(): boolean {
    return _.some(this.validatorErrors, e => e.field === 'password')
  }

  get showPasswordDescription(): boolean {
    if (this.password === '') {
      return true
    }

    return !this.hasPasswordValidationError
  }

  async beforeRouteEnter(_to, _from, next) {
    if (CookieService.isRegistered()) {
      next('/mypage')

      return
    }

    next()
  }

  async validateForm(): Promise<boolean> {
    // To force to validate untouched fields
    this.$validator.fields.map((field) => {
      this.$validator.flag(field.name, {
        touched: true,
      })
    })

    return this.$validator.validateAll()
  }

  async submit() {
    if (this.isRegisteredUser) {
      this.emitError({
        content: 'すでにログイン済みです',
      })

      return
    }

    window.scrollTo(0, 0)

    const validated = await this.validateForm()

    if (!validated) {
      return
    }

    if (!this.isConfirming) {
      this.isConfirming = true

      return
    }

    this.status = Status.Loading

    // add registered_at
    const registeredAt = this.currentTime.now.toJSON()

    const payload: RegistrationPayload = createRegistrationPayload(
      {
        username: this.email,
        password: this.password,
        // Email is also passed because username is email at present.
        email: this.email,
        is_delivery: true,
        registered_at: registeredAt,
      },
      this.mailMagazines
    )

    await this.$store.dispatch('user/register', payload)

    const state: UserState = this.$store.state.user
    const error = state.error.register

    if (error) {
      this.isConfirming = false
      this.status = Status.Failed

      return
    }

    const subscriptionError = state.error.mailMagazine
    if (subscriptionError) {
      this.emitError({
        content: `
          会員登録は成功しましたが、メールマガジン登録に失敗しました。<br/>
          メールマガジンは、アカウントサービスから再登録できます。
        `,
      })
    }

    this.isConfirming = false
    this.status = Status.Completed

    this.scrollToTop()
  }

  onUpdateMailMagazine(updated: RawTag[]): void {
    this.mailMagazines = updated
  }
  failLoadMailMagazine(): void {
    this.emitError({
      content: `
        メールマガジン情報が取得できませんでした。<br/>
        ※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。
      `,
    })
  }

  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop

    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }

  goToPrevious() {
    /*
     * TODO: nextクエリで画面遷移先を指定する機能自体をmixinにしても良いかもしれない
     * nextが例えば /s/mypage など、特にencodeされていない文字列にdecodeしても特に影響はない.
     *
     * @example
     * ```js
     * const url = '/s/paid-membership/new-creditcard'
     * console.log(decodeURI(url)) //=> '/s/paid-membership/new-creditcard'
     *
     * const withQuery = `${url}?next=/s/mypage`
     * console.log(decodeURI(encodeURI(q))) //=> '/s/paid-membership/new-creditcard?next=/s/mypage'
     *
     * const withEncQuery = `${url}?next=${encodeURI('/s/mypage')}`
     * console.log(decodeURI(withEncQuery)) //=> '/s/paid-membership/new-creditcard?next=/s/mypage'
     * ```
     */
    this.goTo(decodeURI(this.next || '/'))
  }

  @Emit('error')
  private emitError(_event: AuthErrorEvent) {
    // only emit event
  }
}
